import { useRouter } from '@fabric-app/compat';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { getUserNavigationHistory, userNavigationHistoryStore } from '../stores/userNavigationHistoryStore.js';

const useTrackUserNavigationHistory = () => {
  const { pathname, ...router } = useRouter();
  useClientLayoutEffect(() => {
    const last = getUserNavigationHistory().lastState;
    const asPath = window.location.pathname + window.location.search;
    if (last?.asPath !== asPath) {
      const lastState = {
        asPath,
        pathname
      };
      userNavigationHistoryStore.setState((state) => {
        return {
          lastState,
          history: [
            lastState,
            ...state.history || []
          ]
        };
      });
    }
  }, [
    router.asPath,
    pathname,
    router
  ]);
};

export { useTrackUserNavigationHistory };
//# sourceMappingURL=useTrackUserNavigationHistory.js.map
